import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import WriteFlights from './WriteFlights';
import './WritePage.css';

function WritePage() {
  const location = useLocation();
  const navigate = useNavigate();

  // Check URL parameters for edit mode (HashRouter stores params in hash)
  const hash = window.location.hash;
  const queryStart = hash.indexOf('?');
  const urlParams = queryStart !== -1 ? new URLSearchParams(hash.substring(queryStart + 1)) : new URLSearchParams();
  const editFromUrl = urlParams.get('edit') === 'true';
  const submissionIdFromUrl = urlParams.get('submissionId');

  // Log the incoming state for debugging
  useEffect(() => {
    console.log('📄 WRITEPAGE LOADED');
    console.log('🎯 Location state:', location.state);
    console.log('🔗 URL params:', { edit: editFromUrl, submissionId: submissionIdFromUrl });
    console.log('✏️ Edit mode:', !!location.state?.edit || editFromUrl);
    console.log('📝 Submission data:', location.state?.submission);
    console.log('🔗 Parent submission ID:', location.state?.parentSubmissionId);
    console.log('🔗 Parent field ID:', location.state?.parentFieldId);
    console.log('📋 Selected template:', location.state?.selectedTemplate);
  }, [location.state, editFromUrl, submissionIdFromUrl]);

  // Backward compatibility: legacy navigation sending mode:'templates'
  useEffect(() => {
    if (location.state && location.state.mode === 'templates') {
      console.log('🔄 Legacy templates mode detected, redirecting...');
      navigate('/flight_tracker/templates', { replace: true });
    }
  }, [location.state, navigate]);

  return (
    <>
      <div className="page write-page-content">
        <h1 className="write-page-heading">Flight Log</h1>
        <WriteFlights 
          edit={!!location.state?.edit || editFromUrl} 
          submission={location.state?.submission || null}
          selectedTemplate={location.state?.selectedTemplate || null}
          parentSubmissionId={location.state?.parentSubmissionId || null}
          parentFieldId={location.state?.parentFieldId || null}
        />
      </div>
    </>
  );
}

export default WritePage; 